import { UseMutationConfig } from 'react-relay';
import { UserActionInput, UserActionMutation } from '../graphQLOperations/__generated__/UserActionMutation.graphql';

export const saveLoginUserActionRetry = async (
  params: {
    saveUserAction: (config: UseMutationConfig<UserActionMutation>) => void;
    payload: UserActionInput;
    maxRetries: number;
    baseDelay: number;
  },
  attempt = 0,
) => {
  if (params.maxRetries === -1) return;
  await new Promise(res => setTimeout(res, params.baseDelay * attempt));
  params.saveUserAction({
    variables: { input: { userAction: params.payload } },
    onError: () => {
      saveLoginUserActionRetry({ ...params, maxRetries: params.maxRetries - 1 }, attempt + 1);
    },
  });
};
